import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, inject } from "@angular/core";
import { VoucherNotificationService } from "src/app/components/vouchers/voucher-notification.service";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { CountDownTimerAppComponent } from "src/app/components/count-down-timer-app/count-down-timer-app.component";
import { CheckWinningsRepositoryService } from "../check-winnings-repository.service";
@Component({
  selector: "app-voucher-collection",
  templateUrl: "./voucher-collection.component.html",
  styleUrls: ["./voucher-collection.component.scss"],
  standalone: true,
  imports: [CommonModule, CountDownTimerAppComponent, TranslatePipe],
})
export class VoucherCollectionComponent implements OnChanges {
  @Input() voucher: Data | null;
  @Input() breakdownId: string;
  countdownSeconds: number | null;
  selectedLanguage: string;
  userId: string;
  @Output() voucherClaimed = new EventEmitter<void>();
  public voucherNotificationService = inject(VoucherNotificationService);
  constructor(
    private checkWinningsRepositoryService: CheckWinningsRepositoryService,
    private authService: AuthService,
    public translate: TranslateService,
    private route: Router
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ?? "en";
        this.translate.use(this.selectedLanguage);
      },
      (err) => err
    );
  }
  async ngOnChanges() {
    await this.authService
      ?.getUid("VoucherCollectionComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });

    if (!this.voucher) return;
    const claimExpiry = this.voucher?.claim_expiry_time?.seconds;
    const voucherExpiry = this.voucher?.voucher_expiry_time?.seconds;

    const now = Date.now();

    if (voucherExpiry && now > voucherExpiry * 1000) {
      if (this.voucher?.claim_status === "claim") {
        this.updateVoucherDetails("expired");
      }
      return;
    }

    if (claimExpiry) {
      const isExpired = now > claimExpiry * 1000;
      if (isExpired) {
        if (this.voucher?.claim_status === "claim") {
          this.updateVoucherDetails("expired");
        }
      } else {
        this.startCountdownMonitor(claimExpiry);
      }
    } else {
      this.updateVoucherDetails();
    }
  }

  claimVoucher(): void {
    this.updateVoucherDetails("claimed", () => {
     this.showToastMessage();
     this.voucherClaimed.emit();
    });
  }


  updateVoucherDetails(claimStatus?: string, onSuccess?: () => void) {
    const userId = this.userId;
    const claimEventId = this.breakdownId;
    this.checkWinningsRepositoryService.setVoucherExpiryAndUpdateStatus(userId, claimEventId,this.voucher, claimStatus, onSuccess);
  }

  startCountdownMonitor(claimExpirySeconds: number): void {
    const expiryTime = claimExpirySeconds * 1000;
    const currentTime = Date.now();
    const secondsLeft = Math.floor((expiryTime - currentTime) / 1000);

    this.countdownSeconds = secondsLeft > 0 ? secondsLeft : 0;
  }

  showToastMessage(): void {
    this.authService
      .getConstantsMsg("1157")
      .then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Added to Voucher wallet",
            line_2: "Your discount is ready to use now!",
          },
          style: {
            icon: "tick circle success.png",
            type: "Success",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
    }).catch((error) => {
      return error;
    });
  }

  handleCountdownFinish(): void {
    if (this.voucher?.claim_status === 'claim') {
      this.updateVoucherDetails('expired');
    }
  }
  // user Redireact To on store page
  useDiscount(){
    this.route.navigateByUrl("/mainTabs/tabs/store")
  }

}
